export default "__VITE_ASSET__Bnz2Jry5__"